"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleConflictFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
const eventFactory = Factory.Sync.makeFactory({
    id: Factory.each(() => uuid_1.v4()),
    originator_id: Factory.each(() => uuid_1.v4()),
    originator_system: 'StatNgin',
    originator_type: 'event',
    program_id: Factory.each(() => uuid_1.v4()),
    timezone: 'America/Chicago'
});
exports.scheduleConflictFactory = Factory.Sync.makeFactory({
    id: Factory.each(() => uuid_1.v4()),
    type: 'team_overbooked',
    resource_system: 'StatNgin',
    resource_type: 'SeasonTeam',
    resource_id: Factory.each(() => uuid_1.v4()),
    resource_name: 'test',
    event_1: eventFactory.build(),
    event_2: eventFactory.build(),
    conflict_date_time: Mocks.dates.date2000,
    created_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000,
});
